import { apiClient } from './ticketsApi';
import { ENDPOINTS } from './endpoints';

export const fetchApiNames = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_API_NAMES}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching API names:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchApiCalls = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_API_CALLS}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching API calls:', error.response?.data || error.message);
        throw error;
    }
};
